import {
  TextReplaceForm,
  type TextReplaceFormValues,
} from '@carboncopyco/editor-ui';
import type { ITextReplaceRule } from '@carboncopyco/types';
import { IFindAndReplaceRuleType } from '@carboncopyco/types';
import {
  useEditor,
  useEditorMetadata,
} from '../../../context/EditorSdkProvider';
import type { IFindAndReplaceRuleState } from '../types';

export type CreateControlsProps = Pick<
  IFindAndReplaceRuleState<ITextReplaceRule>,
  'onSubmit' | 'rules' | 'onCancel' | 'onFocus' | 'autoFocus'
>;

export const CreateControls = ({
  onSubmit,
  onCancel,
  onFocus,
  autoFocus,
  rules,
}: CreateControlsProps) => {
  const editorSdk = useEditor();
  const { location = { encodedUrl: '', decodedUrl: '' } } = useEditorMetadata();

  const createRule = ({ oldValue, newValue, options }: TextReplaceFormValues) =>
    onSubmit({
      type: IFindAndReplaceRuleType.replaceText,
      oldValue,
      newValue,
      options,
    });
  return (
    <TextReplaceForm
      onSubmit={createRule}
      submitText="Add rule"
      onCancel={onCancel}
      onFocus={onFocus}
      autoFocus={autoFocus}
      unlimitedText
      advancedSettings={{
        location,
      }}
      onLearnMoreClick={editorSdk.openUrlLink}
      rules={rules}
    />
  );
};
